/// Header Controller Object.
var hc = null;

/* RESPONSIVE DIMENSIONS */
var responsiveObject = {
  currentDisplay: '',
  dimensions: {
    maxForXSmall    : 480,
    maxForSmall     : 750,
    maxForMedium    : 990,
    maxForWidscreen : 1440
  },
  updateCurrentDisplay: function(windowWidth) {
    var display = '';
    if (windowWidth < responsiveObject.dimensions.maxForXSmall)
      display = 'xs';
    else if (windowWidth < responsiveObject.dimensions.maxForSmall)
      display = 's';
    else if (windowWidth < responsiveObject.dimensions.maxForMedium)
      display = 'm';
    else if (windowWidth < responsiveObject.dimensions.maxForWidscreen)
      display = 'l';
    else if (windowWidth >= responsiveObject.dimensions.maxForWidscreen)
      display = 'w';

    responsiveObject.currentDisplay = display;
    return display;
  }
};

// Touch Detection
window.addEventListener('touchstart', function onFirstTouch() {
  // document.body.classList.add('user-is-touching');

  window.TOUCH_SCREEN = true;

  // we only need to know once that a human touched the screen, so we can stop listening now
  window.removeEventListener('touchstart', onFirstTouch, false);
}, false);


/*================================== SHOPIFY PAGE    ====================*/

function calibrateShopifyBrain () {
  var parentContainer = $('#studio-features');
  if (parentContainer.length == 0)
    return;

  var $features = parentContainer.find('.feature');
  var height = 0;
  $.each($features, function() {
    var tempHeight = $(this).height();
    if (tempHeight > height)
      height = tempHeight;
  });

  $features.height (height);


  var $featuresContainer = parentContainer.find('.features');
  var bgHeight = $featuresContainer.outerHeight()/2;
  var bgTop = $featuresContainer.position().top + $featuresContainer.outerHeight(true) - $featuresContainer.outerHeight()/2;
  var bg = parentContainer.find('.bg');

  bg.css('top', bgTop + 'px');
  bg.height(bgHeight);
};

/* ================================= BLOG PAGE       ====================*/

var articleController = new function () {
  
};

var blogController = new function () {
  var self = this;
  
  var brickGenerator = {};
  var bgContainer = '.rwd';
  var bricksCOntainerParentSelector = '.rwd .rwd-bg';
  var bricksContainerSelector = ".rwd .rwd-bg-bricks";
  
  var containersList = [];
  
  self.init = function () {
    if (!$(bgContainer).length) return;
    // Generate bricks for all background.
//     var options = {
//       container: $(bricksContainerSelector),
//       brickClasses: 'rdw-brick',
//       bricksPerRow: 25,
//       bricksPerColumn: 50
//     };
    
//     brickGenerator = bricksGenerator.init(options);
    
    // Assign events
    $(document).on('mouseenter', bricksCOntainerParentSelector, function (e) {
      var container = $(this);
      // if ($(e.target).closest('.at-quote-container').length) return;
      container.addClass('triggered');
      self.populateQuote(container);
    });

    $(document).on('mouseout', bricksCOntainerParentSelector, function (e) {
      var container = $(this);
      container.removeClass('triggered');
    });
    
    $(document).on('click' , bricksCOntainerParentSelector, function (e) {
      var container = $(this);
      container.toggleClass('triggered');
    });
  }

  self.populateQuote = function ($container) {
    if ($container.data('populated') === true) return;
    $container.data('populated', true)
    var quote = quoteGenerator.random(160);
    
    $container.find('.at-quote').html('').append(quote.content);
    $container.find('.at-quoted').html('').append(quote.title);
  }
};

              
              
/*================================= LOADER CONTROLLER ====================*/

var loaderController = new function () {
  var self = this;
  self.selector = '#loader';
  self.animationDuration = 500;
  self.closeBuffer = 1000;
  
  self.open  = function(before) {
    $(self.selector).removeClass('close');
  }
  
  self.close = function(after) {
    var closeLoader = function () {
      $(self.selector).addClass('close');
      if (typeof after === 'function')
        after();
    }
    setTimeout(function() { closeLoader(); }, self.animationDuration + self.closeBuffer); 
  }
};

/*================================== TOOLS ====================*/

// ANIMATION
var animationController = new function () {
  var self = this;
  self.animatableElementClass = 'animatable';
  self.animationBreakerClass = 'triggered';
  self.selector = '.animatable:not([data-auto-start="disable"]):not(.' + this.animationBreakerClass + ')';
  self.forcedElementsSelector = '.animatable[data-auto-start="force"]';
  self.$elements = null;


  /*
   * Forced elements, if they are visible at document ready, 
   * they should be animated even if the scroll event is not trigerred yet.
   */
  self.playForcedElements = function () {
    $(self.forcedElementsSelector).each(function() {
      var $element = $(this);
      var $ancor = $element;
      if ( $element.data('ancor') && $($element.data('ancor')).length > 0 )
        $ancor = $($element.data('ancor'));
     
      if (self.isVisible($ancor)) $element.addClass(self.animationBreakerClass);
    });
  }
  
  self.onScroll = function() {
    $(self.selector).each(function() {
      var $element = $(this);
      var $ancor = $element;
      if ( $element.data('ancor') && $($element.data('ancor')).length > 0 )
        $ancor = $($element.data('ancor'));
     
      if (self.isVisible($ancor)) $element.addClass(self.animationBreakerClass);
    });
  }

  // Searches for animatable elements in the givin section and triggers them.
  // useful for non-automatic animations.
  // @param {sectionSelector: $object OR dom selector} used to select the target section
  self.animateSection = function (sectionSelector) {
    var parent;
    if (sectionSelector instanceof jQuery)
      parent = sectionSelector;
    else
      parent = $(sectionSelector);
    parent.find('.' + self.animatableElementClass).addClass(self.animationBreakerClass);
  }
  
  // Searches for animatable elements in the givin section and un-triggers them.
  // useful for non-automatic animations.
  // @param {sectionSelector: $object OR dom selector} used to select the target section
  self.unanimateSection = function (sectionSelector) {
    var parent;
    if (sectionSelector instanceof jQuery)
      parent = sectionSelector;
    else
      parent = $(sectionSelector);
    parent.find('.' + self.animatableElementClass).removeClass(self.animationBreakerClass);
  }

  // internal function
  // Checks if an element is visible in the current viewport
  // @param {$t - jquery elemenet} is the current element which should be checked.
  // @param {partially - true/false} whether the element should be fully or partially visible.
  self.isVisible = function ($t, isPartiallyVisible) {
    var $w            = $(window),
        viewTop       = $w.scrollTop(),
        viewBottom    = viewTop + $w.height(),
        _top          = $t.offset().top,
        _bottom       = _top + $t.height(),
        compareTop    = isPartiallyVisible === true ? _bottom : _top,
        compareBottom = isPartiallyVisible === true ? _top : _bottom;

    return ((compareBottom <= viewBottom) && (compareTop >= viewTop)); 
  }
};

var parallaxController = new function () {
  var self = this;
  
  self.triggerAll = function() {			
    var $parallaxContainers = $(".parallaxables-container");
    var fixer = -0.004;		//experiment with the value

    if (!self.shouldTrigger())
      return;
    
    $(document).on("mousemove", function(event){				
      $.each($parallaxContainers, function() {
        var $parallaxContainer = $(this);
        var $parallaxItems = $parallaxContainer.find(".parallaxable");

        var pageX =  event.pageX - ($parallaxContainer.width() * 0.5);  //get the mouseX - negative on left, positive on right
        var pageY =  event.pageY - ($parallaxContainer.height() * 0.5); //same here, get the y. use console.log(pageY) to see the values

        //here we move each item
        $parallaxItems.each(function(){

          var item 	= $(this);
          var speedX	= item.data("speed-x");  				
          var speedY	= item.data("speed-y");

          if (!$(item).data('initial-x') || $(item).data('initial-x') == null) {
            item.data('initial-x', item.position().left);
            item.data('initial-y', item.position().top);
          }
          
          // The item was reset before, and parallax is desactivated.
          if ( $(item).data('inactive'))
            return;
          // the item has not been parallaxed before, and parallax is still active.
          else if (!$(item).data('activated') && self.shouldTrigger())
            $(item).data('activated', true);
          // the item has not been parallaxed before, and parallax is not active.
          else if (!$(item).data('activated') && !self.shouldTrigger()) {
            $(item).data('inactive', true);
            return;
          }
          // the item has been parallaxed before, and parallax is not active anymore.
          else if ($(item).data('activated') && !self.shouldTrigger()) {
            TweenLite.to(item, 0.5, {
              x: item.data('initial-x'), 
              y: item.data('initial-y')
            });
            $(item).data('inactive', true);
            return;
          }
            

          // instead '.to' use '.set' for better performance (but not assmooth)
          if (pageY > 5000) pageY %= 5000;
          TweenLite.to(item, 0.5, {
            x: (item.position().left + pageX * speedX )*fixer,    //calculate the new X based on mouse position * speed 
            y: (item.position().top + pageY * speedY)*fixer
          });
        });

      });
    });				
  };
  
  self.shouldTrigger = function () {
    if (responsiveObject.currentDisplay != 's' && !window.TOUCH_SCREEN )
      return true;
    return false;
  }
  
  self.reset = function () {
    
  }
};

              
var pulsableController = new function () { 
  var self = this;
  var containerSelector = '.pulsable-container';
  var elementSelector = '.pulsable-element';
  var bgSelector = '.bg';
  
  self.init = function () {
    if (!$(containerSelector).length) return;
    
    $(containerSelector).each(function (index) {
      var container = $(this);
      
      var elements = container.find(elementSelector);
      var elementsCount = elements.length;
   
      var offsetArray = [];
      while(offsetArray.length < elementsCount){
        var randomnumber = Math.ceil(Math.random()*elementsCount)
        if(offsetArray.indexOf(randomnumber) > -1) continue;
        offsetArray.push(randomnumber);
      }
      
      elements.append('<div class="bg"></div>');

      elements.each(function (index) {
        var element = $(this);
        var animationDuration = .3 + .3 + 2 + .3 + .3;
        var firstDelay = (offsetArray[index] - 1) * animationDuration;
        var repeatDelay = elementsCount * animationDuration;
        
        TweenMax.delayedCall(firstDelay, self.playAnim, [element, repeatDelay]);
      });
    });
  }
  
  self.playAnim = function (element, repeatDelay) {
    TweenMax.delayedCall(repeatDelay, self.playAnim, [element, repeatDelay]);
    
    var bg = element.find(bgSelector);
    var tl = new TimelineMax();
    tl.to(bg, 0.3, { opacity: 1 });
    tl.to(bg, 0.3, { boxShadow: "1px 1px 1px 4=3px rgba(150,150,150, .2)" });
    tl.to(bg,   2, { opacity: 1 });
    tl.to(bg, 0.3, { boxShadow: "1px 1px 1px 1px rgba(150,150,150, 0)" });
    tl.to(bg, 0.3, { opacity: 0 });
    tl.play();
  };
};

// BRICK GENERATOR
var bricksGenerator = new function () {
  
  var self = this;
  /* Defaults for the $element containing the bricks */
  // The $jquery element that should contain the bricks.
  // Bricks should be contained in a seperate container.
  self.$container = null;
  self.bricksCountPerRow = 0;
  self.bricksCountPerColumn = 0;

  /* Defaults classes & dimensions for each brick */
  self.brickWidth   = 50;
  self.brickHeight  = 14;
  self.brickClasses = '';


  /* transition delay*/
  self.transitionType = 'random'; // in the future maybe add 'sequential'
  self.transitionDelayStep = 10;

  /*
   * example settings:
   * Expected dimensions values are either in PX or %, to be used with jquery's .width(), .height()
   * settings = {
   *   container: $('#myContainer')
   *   // provide bricks dimensions ...
   *   brickHeight: 20,
   *   brickWidth: 50,
   *   // and/or
   *   bricksPerRow: 50,
   *   bricksPerColumn: 50,
   *   // bricks background image
   *   bg: (url string),
   *   // classes to be added to each brick.
   *   brickClasses: 'some classes'
   * }
   */
  this.init = function(settings) {
    /* extract settings */
    if (!settings.container) {
      console.log('[bricksGenerator] No container is specified');
      return;
    }

    self.$container  = settings.container;
    if (settings.hasOwnProperty('brickWidth') && !isNaN(settings.brickWidth) )   
      self.brickWidth  = settings.brickWidth;
    if (settings.hasOwnProperty('brickHeight') && !isNaN(settings.brickHeight))  
      self.brickHeight = settings.brickHeight;
    if (settings.hasOwnProperty('brickClasses') && settings.brickClasses != '' ) 
      self.brickClasses = settings.brickClasses;
  
    /* Logic */

    // empty the current container
    self.$container.html('');
    self.$container.addClass('bricks-container-131');

    // calculate bricks count per row/column
    self.bricksCountPerRow = settings.hasOwnProperty('bricksPerRow')? settings.bricksPerRow : Math.ceil(this.$container.width()  / this.brickWidth);
    self.bricksCountPerColumn = settings.hasOwnProperty('bricksPerColumn')? settings.bricksPerColumn : Math.ceil(this.$container.height() / this.brickHeight);

    // A unique class name generated for each brick group.
    self.uniqueClass = "brick" + (100 + Math.ceil(Math.random() * 10000));
    
    if (settings.hasOwnProperty('bg') && settings.bg.trim() != '') {
      self.bg = settings.bg;

      var img = new Image();
      img.crossOrigin="anonymous"; // to avoid 'tainted canvas' error
      img.onload = function() {
        self.loadBg(img);
      };
      img.src = this.bg;
    }
    else 
      self.drawBricks();
    
    
    return self;
  }
  
  // @param (img): js image that should be loaded.
  // @output self.startX: image x draw position
  // @output self.startY: image y draw position
  // @output self.bgSrc: base 64 image source that should be used as a bg.
  self.loadBg = function (img) {
    // src: https://stackoverflow.com/questions/10285134/whats-the-math-behind-csss-background-sizecover
    var containerWidth = self.$container.width();
    var containerHeight = self.$container.height();

    var imageNaturalWidth = img.naturalWidth;
    var imageNaturalHeight = img.naturalHeight;

    var originalRatios = {
      width: containerWidth / imageNaturalWidth,
      height: containerHeight / imageNaturalHeight
    };

    // formula for cover:
    var coverRatio = Math.max(originalRatios.width, originalRatios.height); 

    // result:
    var newImageWidth = Math.ceil(imageNaturalWidth * coverRatio);
    var newImageHeight = Math.ceil(imageNaturalHeight * coverRatio);

    // formula for center center positioning
    self.startX = 0;
    self.startY = 0;
    if (newImageWidth > containerWidth)
      self.startX = (newImageWidth - containerWidth)/2;

    if (newImageHeight > containerHeight)
      self.startY = (newImageHeight - containerHeight)/2;

    // create new image with the new dimensions
    var c = document.createElement('canvas');
	c.style.display = "none";
    document.body.appendChild(c);
    
    var ctx=c.getContext("2d");
    c.width = newImageWidth;
    c.height = newImageHeight;
    ctx.drawImage(img, 0, 0, newImageWidth, newImageHeight);
    self.bgSrc = c.toDataURL("image/jpeg");
    
    // assign img source to the bricks via the unique class
    var additionalStyles = $('<style>').html('.' + self.uniqueClass + ' { background-image: url("'  + self.bgSrc + '") }');
    $('head').append(additionalStyles);
    
    // Draw bricks after having loaded the image and set the startX/startY
    self.drawBricks();
  }
  
  self.drawBricks = function () {
    var count = 0;
    var content = '';
    for(var y = 1; y <= self.bricksCountPerColumn; y++) {
      var rowWidth  = ' width: ' + ( self.bricksCountPerRow * self.brickWidth) + 'px; ';
      var rowHeight = ' height: ' + self.brickHeight + 'px; ';
      var row = "<div class='bricks-row' style='" + rowWidth + rowHeight + "'>";
      for (var x = 1; x <= this.bricksCountPerRow; x++) {
        count ++;
        var bgColorClass = 'light';
        if ( ( y % 2 === 1 && x % 2 === 1) || (y % 2 === 0 && x % 2 === 0) )
          bgColorClass = 'dark';

        var delay = 0;
        if (self.transitionType == 'random')
          delay = Math.random() * (60 * this.transitionDelayStep - 10) + 10;
        else if (self.transitionType == 'sequential')
          delay = count * self.transitionDelayStep;

        var transitionDelay = "transition-delay:" + delay + "ms;";
        var height = "height:" + self.brickHeight + "px;";
        var width  = "width:" + self.brickWidth + "px;";
        var style  = transitionDelay + width + height;
        if (self.bg) { // If there is an assigned bg
          var posX = -1 * (self.startX + (x-1) * self.brickWidth);
          var posY = -1 * (self.startY + (y-1) * self.brickHeight);
          style += "background-position:" + posX + "px " + posY + "px";
        }
        var classes = self.uniqueClass + ' ' + self.brickClasses + ' ' + bgColorClass + ' brick-131 x-' + x + ' y-' + y + ' id-' + count;
        var div  = "<div class='" + classes + "' style='" + style +"'></div>";
        row += div;
      }
      row += '</div>';
      content += row;
    }
    this.$container.append(content);
  }
};

// INFINITY SCROLLING
// https://gist.github.com/rickydazla/1390610
var scrollingLoadablesController = new function () {
  var self = this;
  
  var pInfScrLoading = false;
  var pInfScrDelay = 100;
  
  var contentContainerSelector = '.loadables-container';
  var loadableItemSelector = contentContainerSelector + ' .grid__item';
  var moreBtnSelector = '.auto-load';
  
  
  self.run = function () {
    if (!$(contentContainerSelector).length) return;
    
    // jQuery.doTimeout( [ id, ] delay, callback [, arg ... ] );
    $.doTimeout( 'scroll', pInfScrDelay, self.loadContent);
    if( $(document).height() - 800 > $(document).scrollTop() + $(window).height() ) {
      pInfScrDelay = 100;
    }
  }
  
  self.loadContent = function () {
    if($(document).height() - 800 >= ($(document).scrollTop() + $(window).height())) return;

    var loadingImage,
        pInfScrNode = $(moreBtnSelector).last(),
        pInfScrURL = $(moreBtnSelector + ' a').last().attr("href");
    if(!pInfScrLoading && pInfScrNode.length > 0 && pInfScrNode.css('display') != 'none') {
      $.ajax({
        type: 'GET',
        url: pInfScrURL,
        beforeSend: function() {
          pInfScrLoading = true;
          loadingImage = pInfScrNode.clone().empty().append('<img src=\"http://cdn.shopify.com/s/files/1/0068/2162/assets/loading.gif?105791\" />');
          loadingImage.insertAfter(pInfScrNode);
          pInfScrNode.hide();
        },
        success: function(data) {
          // remove loading feedback
          pInfScrNode.next().remove();
          var filteredData = $(data).find(loadableItemSelector);
          $(contentContainerSelector).append(filteredData);
          // loable items are boards, then re-init new boards.
          boardController.initBoards();
          //filteredData.insertBefore( $(".loadables-container") );
          loadingImage.remove();					
          pInfScrLoading = false;
        },
        dataType: "html"
      });
    }
  }
};

// Image loader checker
var imageLoader = new function () {
  var self = this;
  
  // used when all images in @container are finished whether loded or broken.
  self.executeAlways = function (container, onSuccess) {
    $(container).imagesLoaded()
    .always( function( instance ) {
      $(container).imagesLoaded( { background: '.has-bg' }, function() {
         if (typeof onSuccess === 'function') onSuccess(); // At the end
      });
    })
    .done( function( instance ) {
//       loaderController.close(function() {
//         // only when successful
//       });
    })
    .fail( function() {  })
    .progress( function( instance, image ) {  });
  }
};

/* ================================= CUSTOM ELEMENTS  ==================== */
// BOARDS
var boardController = new function () {
  var self = this;

  var boardSelector = '.board';
  var boardTitleSelector = '.board-title';
  var boardContentSelector = '.board-content';
  var boardImagaeSelector = '.board-image';

  self.initBoards = function () {
    $(boardSelector).each (function () {
      // set up the height of the board element.
      // becasue the board's title is 'position: absolute'
      var board = $(this);
      var boardTitleHeight = 0;
      if (board.find(boardTitleSelector).length 
          && (responsiveObject.currentDisplay != 's' || responsiveObject.currentDisplay != 'xs'))
        board.css('margin-top', board.find(boardTitleSelector).outerHeight());
      else board.css('margin-top', 0);


      if (board.find(boardContentSelector).length && board.find(boardImagaeSelector).length ) {
        board.find(boardContentSelector).css('margin-top', board.find(boardImagaeSelector).height());
      }
      else if (board.find(boardContentSelector).length == 0 && board.find(boardImagaeSelector).length) {
        var newHeight = board.find(boardImagaeSelector).height();
        if (newHeight > board.height()) {
          board.css('padding', 0);
          board.height(newHeight);
        }
      }
      else board.find(boardContentSelector).css('margin-top', 0);
    });
  }
};
              
// HALFS 
var halfsController = new function () {
  var self = this;
  self.wrapperSelector = '.halfs-container-wrapper';
  self.tightWrapperSelector = '.halfs-tight-wrapper';
  self.ancorSelector = '.ancor';
  self.dependantSelector = '.dependant';
  self.dependant2Selector = '.second-dependant';
  self.upperInfo = '.padding-info-bottom';
  self.lowerInfo = '.padding-info-top';
  self.thirdInfo = '.padding-info-third';
  self.heightShiftRatio = 85/100;

  this.setDimensions = function() {
    var $elements = $(self.wrapperSelector);
    $.each($elements, function() {
      var currentWrapper = $(this);
      var addPadding = currentWrapper.hasClass('padded');
      
      var height = currentWrapper.find(self.ancorSelector).height() + 
          self.heightShiftRatio * currentWrapper.find(self.dependantSelector).height() +
          self.heightShiftRatio * currentWrapper.find(self.dependant2Selector).height();
      currentWrapper.height(height);
 
      var ancor_line_Width = currentWrapper.find(self.ancorSelector).outerWidth(true) 
      			+ currentWrapper.find(self.upperInfo).outerWidth(true);
      var dependant_line_Width = currentWrapper.find(self.dependantSelector).outerWidth(true) 
      			+ currentWrapper.find(self.lowerInfo).outerWidth(true);
      var secondDependant_line_Width = currentWrapper.find(self.dependant2Selector).outerWidth(true) 
      			+ currentWrapper.find(self.thirdInfo).outerWidth(true);
      
      var width = ancor_line_Width;
      if (dependant_line_Width > width) width = dependant_line_Width;
      if (secondDependant_line_Width > width) width = secondDependant_line_Width;
      
      currentWrapper.find(self.tightWrapperSelector).width(width);
      
      if (addPadding) {
        var paddingLeft = width - currentWrapper.find(self.ancorSelector).outerWidth(true);
        currentWrapper.css('padding-left', paddingLeft);
      }
      
    });
  }
};
              
// BUTTON
              
// disable click events on loader-container.
$( ".loader-container" ).click(function( event ) {
  event.stopPropagation();
});
              
var btn_131 = new function() {
  var self = this;
  // $Q selectors
  self.selector = '.btn'; 
  self.leadingLineSelector = 'leading-line';

  self.load = function ($btn) {
    $btn.css("pointer-events", "none");
    $btn.addClass('active-loading');
    $btn.find(self.leadingLineSelector).hide();
  }
  
  self.endLoading = function ($btn) {
    $btn.find(self.leadingLineSelector).show();
    $btn.removeClass('active-loading');
    $btn.css("pointer-events", "auto");
  }
  
  self.init = function() {
    return;
  }
};
              
// POPUP
var popup_131 = new function (){
  // $Q selectors
  var popupContainer, 
      popupBricksContainer, 
      popupOuterContainer, 
      popupInnerContainer, 
      popupHeader, 
      popupCloseCross,
      popupTitle, 
      popupBody;
  // The object popup instance of the brickGenerator
  var popupBrickGenerator = {};
  // Bricks dimensions
  var brickHeight = 14;
  var brickWidth  = 50;

  this.isOpen = false;

  /*
   * example settings:
   * 
   * settings = {
   *   title: 'Message',
   *   body: 'Something information',
   * }
   */
  this.open   = function(settings, before, after) {
    if (typeof before == 'function')
      before();
    if (this.isOpen) 
      this.close();

    popupTitle.html(settings.title);
    popupBody.html(settings.body);

    popupContainer.addClass('show');

    if (typeof after == 'function')
      after();
  };

  this.close = function(before, after) {
    if (typeof before == 'function')
      before();
    popupContainer.removeClass('show');
    if (typeof after == 'function')
      after();
  }

  this.init = function (options) {
    popupContainer = $('#popup-131');
    popupOuterContainer = popupContainer.find('.popup-container');
    popupInnerContainer = popupContainer.find('.popup-inner-container');
    popupCloseCross = popupContainer.find('.close-container');
    popupHeader = popupContainer.find('.popup-header');
    popupTitle = popupContainer.find('.popup-title');
    popupBody = popupContainer.find('.popup-body');
    popupBricksContainer = popupContainer.find('.popup-bg');

    var tempSyles = $('<style>').html('.temp-styles { display: block !important; opacity: 0!important;}');
    $('head').append(tempSyles);


    popupContainer.addClass('temp-styles');
    // Build background bricks.
    var options = {
      container: popupBricksContainer,
      brickHeight: brickHeight,
      brickWidth: brickWidth,
      brickClasses: 'popup-brick'
    };
    popupBrickGenerator = bricksGenerator.init(options);

    popupContainer.removeClass('temp-styles');
    tempSyles.remove();

    var self = this;
    popupCloseCross.click(function() {
      self.close();
    });

    popupContainer.click(function(){
      self.close();

    })                                            
    popupOuterContainer.click(function(e){
      e.stopPropagation();
    })
  };
};

// Home full height section controller.
var fullHeightSection = new function () {
  var self = this;
  
  var $outerWrapper
  , innerWrapperSelector = '.section-body';
  
  self.initAll = function () {
    $outerWrapper = $('.full-height-section');
    
    $.each($outerWrapper, function () {
      self.initOne($(this));
    });
  }
  
  self.initOne = function ($section) {
    var windowHeight = $(window).height();
    var $innerWrapper = $section.find(innerWrapperSelector);

    if (windowHeight * 1.2 < $innerWrapper.height() ) {
      $section.height($innerWrapper.height() + windowHeight * .2);
    }
    else 
      $section.height(windowHeight);
  }
};
              
/*================================= SECTIONS ========= */

// HEADER
var headerController = new function () {
  var self = this;

  self.isAnimated = false;
  self.$header = null;
  self.$logo = null;
  self.$logoContainer = null;
  self.$menuIcon = null;
  self.$menuIconContainer = null;


  self.onScroll = function () { }
  self.onResize = function () {
    window.menuController.init();
  }

  self.init = function() {
    self.$header = $('#main-header');
    self.$logo = $('.header-logo .logo');
    self.$logoContainer = $('#main-header .header-logo');
    self.$menuIcon = $('#menu-icon-container');
    self.$menuIconContainer = $('#main-header .header-menu-icon');
    
    self.initMenuIcon();
    self.initMenu();
    
    var loader = $('#loader');
    self.animateLoaderHeader = new TimelineMax();
    self.animateLoaderHeader.to(loader, 0.5, { opacity: 0, zIndex: -1 });
//    self.animateLoaderHeader.to(loader.find('.logo-container'), 0.5, { scale: 8 }, 0);
    self.animateLoaderHeader.to(self.$menuIcon.find('.menu-element'),  0.5, { width: '100%' });
    self.animateLoaderHeader.staggerFrom(self.$logo.find('.logo-dash'), .5, {scaleY: 0}, 0.2);
//     self.animateLoaderHeader.fromTo(self.$logo.find('.logo-dash'), 0.5, {scaleY: 0}, {scaleY: 1});
//     self.animateLoaderHeader.to(self.$logo.find('.logo-dash'), 0.5, { scaleY: 1 });

    return self;
  }
  
  self.openSite = function () { 
    self.animateLoaderHeader.play();
  }

  self.loadSite = function () { 
    self.animateLoaderHeader.reverse();
  }
  
  self.animate = function () {  
    self.$logo.addClass('triggered');
    setTimeout(function(){
      self.$menuIcon.addClass('triggered');
      self.isAnimated = true; 
    }, 300);
   
  }
  
  self.deanimate = function () {
    self.$logo.removeClass('triggered');
    self.$menuIcon.removeClass('triggered');
  }

  self.isAnimated = function () {
    return self.isAnimated; 
  }

  self.initMenuIcon = function() {
    var logoHeight     = self.$logoContainer.outerHeight();
    var menuIconHeight = self.$menuIcon.outerHeight();
    var freeHeight     = Math.abs(logoHeight - menuIconHeight);
    self.$menuIconContainer.css({
      'margin-top': freeHeight/2
    });
  }

  self.initMenu = function() {
    window.menuController.init();

    // Open menu
    self.$menuIcon.click(function() {
      window.menuController.open();
    });
  }
};

// DROP VIDEO / CAREER SECTION
var careerSectionController = new function () {
  this.animate = function() {
    var $video = $('#dropVideo');
    if ( $video.length == 0 ||
        ! $video.visible(true) || 
        $video.hasClass('triggered')) 
      return;

    $video.addClass('triggered');

    var myVideo = document.getElementById("dropVideo");
    myVideo.play();
	myVideo.loop = true;
    /*
      myVideo.addEventListener('ended', function() { 
        this.currentTime = 3290;
        this.pause(); 
      }, false);
    */
  }
};
              
// PORTFOLIO
var portfolioController = new function () {
  var self = this;
  
  var root, slidsParent, slides, currentSlideIndex, totalSlidesIndex;
  
  self.init = function () {
    root = $('#portfolio');
    slidsParent = root.find('.slides-container');
    slides = slidsParent.find('.slide');
    
    currentSlideIndex = root.find('.current-slide-number');
    totalSlidesIndex = root.find('.total-slides-count');
    
    var totalSlidesText = slides.length > 10? '': '0';
    totalSlidesText += slides.length;
    
    slidsParent.slick({
      centerMode: true,
      centerPadding: '20%',
      arrows: false,
      slidesToShow: 1,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            arrows: false,
            centerMode: true,
            centerPadding: '20%',
            slidesToShow: 1
          }
        },
        {
          breakpoint: 480,
          settings: {
            arrows: false,
            centerMode: true,
            centerPadding: '5%',
            slidesToShow: 1
          }
        }
      ]
    });

    // Detect slide change inorder to modify the current slide number.
    // @currentSlide: 0 based index.
    slidsParent.on('beforeChange', function(event, slick, currentSlide, nextSlide){
      var adjustedCurrentSlide = nextSlide + 1;
      var text = adjustedCurrentSlide < 10? '0': '';
      text += adjustedCurrentSlide;

      currentSlideIndex.animate({
        opacity: .2
      }, 250, "linear", function() {
        currentSlideIndex.text(text);
        currentSlideIndex.animate({ opacity: 1 }, 250 );
      });
            
    });
  }
  
  self.resizeProjectLinks = function () {
    // Resize link text
    var options = {};
    options.maxfont = 24;
    $('.portfolio-project-link').resizeText(options);
  };
};
/*================================== HOME PAGE CONTROLLER ================*/
var homeController = new function () {
  var self = this;
  
  self.mainWrapper = '#first-section';
  self.headerSlideSelector = '#homeHeaderSlide';
  self.headerObject = null;
  
  self.isHomePage = function() {
    return $('.template-index').length > 0;
  }

  // - add necessary margin below the home slider (2 times header height).
  // - function/library to determine scrolling_up or scrolling_down.
  // - if scrolling down: scale home slide down & fade letters one by one.
  // - otherwise: scal up and show letters one by one.
  self.initAll = function(ho) {
    if (!self.isHomePage) return;
    
    if (ho != undefined && ho != null) self.headerObject = ho;
    if (!self.headerObject.isAnimated) {
      setTimeout(function(){ self.initAll(); }, 300);
      return;
    }
    
    setTimeout(function(){ 
      // self.initClouds();
    }, 300);

    $(window).scroll(function(e) {
      self.homeHeroScroll();
    }); 
  }

  var homeHeroIsOn = true;
  var fromTop_old = 0;
  self.homeHeroScroll = function () {
    var fromTop = $(document).scrollTop();
    var windowHeight = $(window).height();
    
    var diff = fromTop - fromTop_old;
    fromTop_old = fromTop;


    // direction should be considered.
    // warning from Mozilla should be considered
    // should hide the home slide at the end of the animation.
    if (fromTop >= windowHeight * .05 && homeHeroIsOn && diff > 0) {
      homeHeroIsOn = false;
      self.animateHomeHero(homeHeroIsOn);
    }
    else if ( fromTop < windowHeight * .15 && !homeHeroIsOn && diff < 0) {
      homeHeroIsOn = true;
      self.animateHomeHero(homeHeroIsOn);
    }
  }

  var headerLogo = $('.header-logo');
  var menuIcon = $('.header-menu-icon');
  var topBar = $('#header-title .header-bar-top');
  var topText = $('#header-title .top-text');
  var middleBar = $('#header-title .header-bar-middle');
  var middleText = $('#header-title .middle-text');
  var bottomText = $('#header-title .bottom-text');
  var shopifyExpertsText = $('#header-title .experts-text');
  
  var windowWidth = $(window).width();
  var mainSlide_tl = new TimelineLite( { paused: true } );
  mainSlide_tl.to(topBar, .6, { left: -windowWidth/2, opacity: 0, height: 0 });
  mainSlide_tl.to(middleBar, .6, { left: windowWidth/2, opacity: 0, height: 0 }, 0);
  mainSlide_tl.to(topText, .3, { left: "-=100" }, 0);
  mainSlide_tl.to(middleText, .3, { left: "+=100" }, 0);
  mainSlide_tl.to(topText, .3, { opacity: 0 }, .05);
  mainSlide_tl.to(middleText, .3, { opacity: 0 }, .05);
  mainSlide_tl.to(bottomText, .5, { opacity: 0, top: "-=50" }, .2);
  mainSlide_tl.to(shopifyExpertsText, .5, { opacity: 0 }, .3);
  
  self.animateHomeHero = function (status) {
    if (status) // switchon
      mainSlide_tl.reverse();
    else
      mainSlide_tl.play();
  }
  
  self.onScroll = function () {
    if (!self.isHomePage) return;
    
    self.initClouds();
    careerSectionController.animate();
  }

  self.animateHeaderSlide = function (){
    if (!self.isHomePage) return;
    if (!self.headerObject.isAnimated) {
      setTimeout(function(){ self.animateHeaderSlide(); }, 600);
      return;
    }
    
    animationController.animateSection(self.headerSlideSelector);
  }
  
  self.initClouds = function () {
    var fromBottom = 0;
    for (var i = 1; i <= 4; i++) {
      var $cloud = $('#first-section .cloud-' + i);
      if (i != 1) $cloud.css('bottom', fromBottom + 'px');
      fromBottom += $cloud.height() * 0.7;
    }
  }
};

/*================================== MENU ==============================*/
(function(window){

  'use strict';
  function menu(){

    var _menuObject  = {};

    var linksCount, bricksCount, bricksHeight, paddingBricksCount;
    var bricksWidth = 50;
    var additionalStyles = null;

    _menuObject.open = function (after) {
      $('#menu').addClass('show');
      if (typeof after === 'function')
        after();
    }

    _menuObject.close = function (after) {
      $('#menu').removeClass('show');
      if (typeof after === 'function')
        after();
    }

    _menuObject.init = function () {
      linksCount  = $('#menu .menu-link').length;
      bricksCount  = linksCount * 7 + 13;
      bricksHeight = Math.floor( $(window).height() / bricksCount);

      // Build background bricks.
      var options = {
        container: $('#menu .menu-bg'),
        brickHeight: bricksHeight,
        brickWidth: bricksWidth,
        bg: "https://cdn.shopify.com/s/files/1/1631/6021/files/menu-bg.png?17143914263523527014",
        brickClasses: 'menu-brick'
      };
      bricksGenerator.init(options);

      // Add styles to the menu links.
      if (additionalStyles != null)
        additionalStyles.remove();

      additionalStyles = $('<style>').html('.brick-height { height: ' + 1  * bricksHeight + 'px; }' +
                                           '.close-height { height: ' + 13 * bricksHeight + 'px; }' +
                                           '.first-gap    { margin-top: ' + 13 * bricksHeight + 'px; }' +
                                           '.short-gap    { height: ' + 2 * bricksHeight + 'px;  margin    : ' + 2 * bricksHeight + 'px auto; }' +
                                           '.long-gap     { height: ' + 2 * bricksHeight + 'px;  margin-top: ' + 2 * bricksHeight + 'px;     margin-bottom: ' + 4 * bricksHeight + 'px;}' + 
                                           '.last-gap     { height: ' + 1 * bricksHeight + 'px;  margin-top: ' + 1 * bricksHeight + 'px;}');

      $('head').append(additionalStyles);

      $('#menu .close-container').addClass('close-height');
      $('#menu .menu-inner-container').addClass('first-gap');
      $('#menu .menu-link').addClass('brick-height');
      $('#menu .menu-link-container.normal:not(:last-child) .menu-link-separator-container').addClass('short-gap');
      $('#menu .menu-link-container.normal:last .menu-link-separator-container').addClass('long-gap');
      $('#menu .menu-link-container:last .menu-link-separator-container').addClass('last-gap');
      $('#menu .menu-link').resizeText();    


      $('.menu-link').mouseenter(function() {
        var topOffset = $(this).offset().top - $(window).scrollTop();
        var blocksFromTop = Math.floor(topOffset/bricksHeight);
        var linkBlockNumber = blocksFromTop + 1;

        var topLeftCornerSelector      = '#menu .menu-bg .menu-brick.y-' + (linkBlockNumber - 2) + '.x-2';
        var topRightCornerSelector     = '#menu .menu-bg .menu-brick.y-' + (linkBlockNumber - 2) + '.x-5';
        var bottomLeftCornerSelector   = '#menu .menu-bg .menu-brick.y-' + (linkBlockNumber + 2) + '.x-2';
        var bottomRightCornerSelector  = '#menu .menu-bg .menu-brick.y-' + (linkBlockNumber + 2) + '.x-5';

        $(topLeftCornerSelector)    .addClass('block-hover');
        $(topRightCornerSelector)   .addClass('block-hover');  
        $(bottomLeftCornerSelector) .addClass('block-hover');  
        $(bottomRightCornerSelector).addClass('block-hover');  
      });

      $('.menu-link').mouseleave(function() {
        $('#menu .menu-bg .menu-brick').removeClass('block-hover');
      });

      $('.close-cross').click(function() {
        _menuObject.close();
      });
    };

    return _menuObject;
  }

  if(typeof(window.menuController) === 'undefined')
    window.menuController = menu();

})(window);

/*================================== LAUNCHERS ==============================*/
var smoothStateOptions = {
    debug: true,
    anchors: 'a',
    hrefRegex: '',
    forms: 'form',
    allowFormCaching: true,
    repeatDelay: 800, // to prevent double clicks 
    blacklist: '.no-smoothState',
    prefetch: false,
    prefetchOn: '',
    cacheLength: 5,
    loadingClass: 'is-loading',
    scroll: true,
    onBefore: function($currentTarget, $container) {
      console.log('log');
//       loaderController.open();
//       headerController.deanimate();
      headerController.loadSite();
    },
    onStart: {
      // How long this animation takes
      duration: 0,
      // A function that dictates the animations that take place
      render: function ($container) { 
        console.log('log');
      }
    },
    onProgress: {
      // How long this animation takes
      duration: 0,
      // A function that dictates the animations that take place
      render: function ($container) {
        console.log('log');
      }
    },
    onReady: {
      duration: 0,
      // `$container` is a `jQuery Object` of the the current smoothState container
      // `$newContent` is a `jQuery Object` of the HTML that should replace the existing container's HTML.
      render: function ($container, $newContent) {
        // Update the HTML on the page
        console.log('onReady');
        $container.html($newContent);
      }
    },
    onAfter: function($container, $newContent) {
      // need state manager?
      if (window.ga)
        window.ga('send', 'pageview', window.location.pathname || url);
      $('body').attr('class', '').addClass($('#state').data('template'));
      
//       loaderController.close();
//       setTimeout(function(){
//         window.scrollTo(0, 0);
//         headerController.animate();
//       }, 1600);
      window.scrollTo(0, 0);
      headerController.openSite();
    }
  }

function onReady () {
  
  
  // properties:
  // href: URL of the content that is currently displayed.
  // chash: An object containing the cached pages after they are requested.

  $('#inner-body').smoothState(smoothStateOptions);
  
  // scroll to top 
  window.scrollTo(0, 0);

  // activate tooltipster
  $('.tooltip').tooltipster();
  
  // Favicon switcher
  $(window).focus(function() {
    var onIcon = $("#favicon").data('on');
    $("#favicon").attr("href", onIcon);
  });

  $(window).blur(function() {
    var offIcon = $("#favicon").data('off');
    $("#favicon").attr("href",offIcon);
  });
  
  // INPUTS
  $('.input-container')
  .on('blur', 'input, select, textarea', function(){
    $(this).closest('.input-container').removeClass('focus');
  })
  .on('focus', 'input, select, textarea', function(){
    $(this).closest('.input-container').addClass('focus');
  })
  .on('change', 'input, select, textarea', function(){
    if ($(this).val().trim().length > 0) $(this).closest('.input-container').addClass('populated');
    else $(this).closest('.input-container').removeClass('populated');
  });

  // update the responsiveObject
  responsiveObject.updateCurrentDisplay($(window).width());

  // initiate portfolio
  portfolioController.init();
  
  // initiate the popup.
  //popup_131.init();

  // Initiate buttons
  btn_131.init();
  
  // Initiate boards
  boardController.initBoards();

  halfsController.setDimensions();

  // header controllers
  hc = headerController.init();
  hc.animate();

  // Pulse animation -- used in blog page.
  pulsableController.init();

  // parallax 
  parallaxController.triggerAll();

  // Animatables
  animationController.playForcedElements();

  // full height controller.
  fullHeightSection.initAll();

  //////////////////// page specific controllers.

  /// home page controllers.
  homeController.initAll(hc);
  homeController.animateHeaderSlide();

  /// SHOPIFY PAGE CONTROLLER
  calibrateShopifyBrain();
  
  /// BLOG 
  blogController.init();
  
  //////////////////// TERMINATE LOADING
  // loaderController.close();
  headerController.openSite();
}

$(document).ready(function() { 
  imageLoader.executeAlways('#inner-body', onReady);
});

$(window).on('scroll', function (){
  animationController.onScroll();

  /// Home page controllers.
  homeController.onScroll();
  
  /// Infinity scrolling controller
  scrollingLoadablesController.run();
});

// WINDOW RESIZE
$(function() {
  var resizeTimer;
  $(window).resize(function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
      headerController.onResize();
      halfsController.setDimensions();

      // full height controller.
      fullHeightSection.initAll();
      // update the responsiveObject
      responsiveObject.updateCurrentDisplay($(window).width());
      // reinitiate the popup.
      //popup_131.init();
      // re-initiate boards
      boardController.initBoards();
      // shopify page
      calibrateShopifyBrain();
    }, 300);
  });
});









var quoteGenerator = new function () {
  var self = this;
  var quotes=[{ID: 10002, title:"Mary Lou Cook", content: "Creativity is inventing, experimenting, growing, taking risks, breaking rules, making mistakes and having fun.", link: ""}, {ID: 10001, title:"Antoine de Saint-Exupéry", content: "Perfection is achieved, not when there is nothing more to add, but when there is nothing left to take away.", link: ""},{ID:1859,title:"Sara Genn",content:"<p>Having a favourite colour is like having a favourite lung.</p>\n",link:"https://quotesondesign.com/sara-genn/"},{ID:1081,title:"Pablo Picasso",content:"<p>Every act of creation is first an act of destruction.  </p>\n",link:"https://quotesondesign.com/pablo-picasso-5/"},{ID:676,title:"Duane Michals",content:"<p>It&#8217;s not in the vulgar, it&#8217;s not in the shock that one finds art. And it&#8217;s not in the excessively beautiful. It&#8217;s in between; it&#8217;s in nuance.   </p>\n",link:"https://quotesondesign.com/duane-michals/"},{ID:2080,title:"Ken Dyment",content:"<p>In design, there is no such thing as &#8220;rules&#8221;. There is however, common sense.</p>\n",link:"https://quotesondesign.com/ken-dyment/"},{ID:1390,title:"Hugh Macleod",content:"<p>Nobody can tell you if what you&#8217;re doing is good, meaningful or worthwhile. The more compelling the path, the more lonely it is.  </p>\n",link:"https://quotesondesign.com/hugh-macleod/"},{ID:2046,title:"Jonah Lehrer",content:"<p>Rejection process is not fun. It&#8217;s the red pen on the page, the discarded sketch, sometimes is the only way forward.</p>\n",link:"https://quotesondesign.com/jonah-lehrer-2/",custom_meta:{Source:'<a href="https://vimeo.com/45162748">video</a>'}},{ID:656,title:"Henry Ford",content:"<p>Whether you think you can or whether you think you can&#8217;t &#8211; you are right.  </p>\n",link:"https://quotesondesign.com/henry-ford-2/"},{ID:1091,title:"Joshua Blankenship",content:"<p>But the web will still be full of arrogant, uninformed, polarizing, self-promoting, controversy-creating content that has ramifications no one wants to own up to. And consequently, the web will still be lacking in common courtesy, humility, and the admittance that most of us don&#8217;t know best. Which is sad, mostly because it&#8217;s true.  </p>\n",link:"https://quotesondesign.com/joshua-blankenship/",custom_meta:{Source:'<a href="http://soserio.us/creating-controversy/">article</a>'}},{ID:1647,title:"Kun-Hee Lee",content:"<p>An enterprise&#8217;s most vital assets lie in its design and other creative capabilities.</p>\n",link:"https://quotesondesign.com/kun-hee-lee/",custom_meta:{Source:'<a href="http://www.fastcompany.com/magazine/101/samsung.html?page=0%2C1">article</a>'}},{ID:1687,title:"Justin Ahrens",content:"<p>Design can have many types of soul, the key is to have one.</p>\n",link:"https://quotesondesign.com/justin-ahrens/"},{ID:915,title:"Neil Gaiman",content:"<p>The world always seems brighter when you&#8217;ve just made something that wasn&#8217;t there before.  </p>\n",link:"https://quotesondesign.com/neil-gaiman/",custom_meta:{Source:'<a href="http://sushiandrobots.com/journal/archives/2009/05/10/quote-neil-gaiman/">elsewhere</a>'}},{ID:1255,title:"Saul Bass",content:"<p>I want everything we do to be beautiful. I don&#8217;t give a damn whether the client understands that that&#8217;s worth anything, or that the client thinks it&#8217;s worth anything, or whether it is worth anything. It&#8217;s worth it to me. It&#8217;s the way I want to live my life. I want to make beautiful things, even if nobody cares.  </p>\n",link:"https://quotesondesign.com/saul-bass-2/",custom_meta:{Source:'<a href="http://www.youtube.com/watch?v=tfDCNpaPBiA&feature=player_embedded">video</a>'}},{ID:1043,title:"Paul Heckel",content:"<p>Because every person knows what he likes, every person thinks he is an expert on user interfaces.  </p>\n",link:"https://quotesondesign.com/paul-heckel/"},{ID:1782,title:"David Ogilvy",content:"<p>The best ideas come as jokes. Make your thinking as funny as possible.</p>\n",link:"https://quotesondesign.com/david-ogilvy-6/"},{ID:1713,title:"Johnnie Manzari",content:"<p>Smart people are attracted to stories, not feature lists.</p>\n",link:"https://quotesondesign.com/johnnie-manzari/"},{ID:1316,title:"Lukas Mathis",content:"<p>I don’t read inspiring books. I find that such books give me a temporal high, but they don’t give me the power to actually follow through. In fact, I suspect these books often serve as a substitute for actual success, rather than as a way of helping people achieve success. By reading inspiring books, you can experience success vicariously; they free you from having to achieve things yourself.  </p>\n",link:"https://quotesondesign.com/lukas-mathis-2/",custom_meta:{Source:'<a href="http://howtogetfocused.com/chapters/how-software-engineers-and-designers-can-increase-their-focus/">interview</a>'}},{ID:1449,title:"Douglas Adams",content:"<p>The major difference between a thing that might go wrong and a thing that cannot possibly go wrong is that when a thing that cannot possibly go wrong goes wrong it usually turns out to be impossible to get at or repair. </p>\n",link:"https://quotesondesign.com/douglas-adams-3/"},{ID:734,title:"Giulio Pinotti",content:"<p>Roses are red, violets are blue. I wont send the job unless you pay me.  </p>\n",link:"https://quotesondesign.com/giulio-pinotti/"},{ID:40,title:"Jenaiha Woods",content:"<p>Design is the contrast of the core of limitations therefore there are no boundaries. It is simply an interpretation of creativity.  </p>\n",link:"https://quotesondesign.com/jenaiha-woods/"},{ID:940,title:"Mike Hicks",content:"<p>Computer design is quite often merely bad design done on a computer.  </p>\n",link:"https://quotesondesign.com/mike-hicks/"},{ID:2328,title:"Pete Episcopo",content:"<p>Everything we do communicates.</p>\n",link:"https://quotesondesign.com/pete-episcopo-2/"},{ID:900,title:"William Shakespeare",content:"<p>I fill up a place, which may be better… when I have made it empty.  </p>\n",link:"https://quotesondesign.com/william-shakespeare/",custom_meta:{Source:'<a href="http://books.google.com/books?id=4MsjAAAAMAAJ&pg=PA195&lpg=PA195&dq=I+fill+up+a+place,+which+may+be+better%E2%80%A6+when+I+have+made+it+empty.&source=bl&ots=p_Cu3KNOrV&sig=72DMK48Ac0Kuho0gSj1HVOkfoAY&hl=en&ei=fq-WSv6VK5LENru7tcgP&sa=X&oi=book_result&ct=result&resnum=7#v=onepage&q=I%20fill%20up%20a%20place%2C%20which%20may%20be%20better%E2%80%A6%20when%20I%20have%20made%20it%20empty.&f=false">book</a>'}},{ID:438,title:"Drew Davies",content:"<p>Good design must be defined by appropriateness to audience and goals, and by its effectiveness, not by its adherence to Swiss design or the number of awards it wins.  </p>\n",link:"https://quotesondesign.com/drew-davies/",custom_meta:{Source:'<a href="http://www.underconsideration.com/speakup/archives/002462.html#032043">comment</a>'}},{ID:1411,title:"Charlie Chaplin",content:"<p>That’s what all we are: amateurs. We don’t live long enough to be anything else.  </p>\n",link:"https://quotesondesign.com/charlie-chaplin/"},{ID:231,title:"Mark Vonnegut",content:"<p>When I complained about being paid fifty dollars for an article that had taken me a week to write, he [Kurt] said I should take into account what it would have cost me to take out a two-page ad announcing that I could write.  </p>\n",link:"https://quotesondesign.com/mark-vonnegut/",custom_meta:{Source:'<a href="http://www.amazon.com/gp/product/0399155082?ie=UTF8&tag=css-tricks-20&linkCode=as2&camp=1789&creative=390957&creativeASIN=0399155082">book</a>'}},{ID:1853,title:"Cecil B. DeMille",content:"<p>Creativity is a drug I cannot live without.</p>\n",link:"https://quotesondesign.com/cecil-b-demille/"},{ID:1506,title:"Jean Auguste Dominique Ingres",content:"<p>Draw lines, young man, many lines; from memory or from nature &#8211; it is in this way you will become a good artist. (said to Edgar Degas)</p>\n",link:"https://quotesondesign.com/jean-auguste-dominique-ingres/"},{ID:871,title:"Paul Rand",content:"<p>Design is the silent ambassador of your brand.  </p>\n",link:"https://quotesondesign.com/paul-rand-6/"},{ID:590,title:"Bernice Fitz-Gibbon",content:"<p>Creativity often consists of merely turning up what is already there. Did you know that right and left shoes were thought up only a little more than a century ago?  </p>\n",link:"https://quotesondesign.com/bernice-fitz-gibbon/"},{ID:956,title:"Abraham Maslow",content:"<p>When the only tool you own is a hammer, every problem begins to resemble a nail.  </p>\n",link:"https://quotesondesign.com/abraham-maslow/"},{ID:2161,title:"Steve Krug",content:"<p>Don’t let your design resist your readers. Don’t let it stand in the way of what they want to do: read.</p>\n",link:"https://quotesondesign.com/steve-krug-4/"},{ID:520,title:"Ståle Melvær",content:"<p>Stop looking at yourself as a designer, and start thinking of yourself as a deliverer of ideas.  </p>\n",link:"https://quotesondesign.com/stale-melv%c3%a6r/"},{ID:526,title:"Wayne Hunt",content:"<p>Graphic designers are, by and large, selfish and spoiled. They stubbornly control and individually design things that a generally smaller than them, perfecting to a level appreciated only by people like them. They don&#8217;t share and play well with others.  </p>\n",link:"https://quotesondesign.com/wayne-hunt/"},{ID:2122,title:"Karen McGrane",content:"<p>Give a crap. Don’t give a fuck.</p>\n",link:"https://quotesondesign.com/karen-mcgrane-2/",custom_meta:{Source:'<a href="http://alistapart.com/column/give-a-crap-dont-give-a-fuck">Paraphrasing Jason Scott</a>'}},{ID:1212,title:"Albert Einstein",content:"<p>If at first the idea is not absurd, then there is no hope for it.  </p>\n",link:"https://quotesondesign.com/albert-einstein-5/"},{ID:2271,title:"Bill Bernbach",content:"<p>I warn you against believing that advertising is a science.</p>\n",link:"https://quotesondesign.com/bill-bernbach-4/"},{ID:2207,title:"Robert Nealan",content:"<p>Man up, admit it isn’t good enough, and fix it now.</p>\n",link:"https://quotesondesign.com/robert-nealan/",custom_meta:{Source:'<a href="http://robertnealan.com/m-v-p-not-m-v-p-o-s/">article</a>'}},{ID:176,title:"Erik Spiekermann",content:"<p>You are what you are seen to be.  </p>\n",link:"https://quotesondesign.com/erik-spiekermann/",custom_meta:{Source:'<a href="http://typophile.com/node/16786">website</a>'}},{ID:909,title:"Dylan Thomas",content:"<p>You can tear a poem apart to see what makes it tick&#8230; You&#8217;re back with the mystery of having been moved by words. The best craftsmanship always leaves holes and gaps&#8230; so that something that is not in the poem can creep, crawl, flash or thunder in.  </p>\n",link:"https://quotesondesign.com/dylan-thomas/"},{ID:2387,title:"Shawn Lukas",content:"<p>A portfolio as pretty as pictures is nothing but a tip of the iceberg, the real treasure underlies the ocean.</p>\n",link:"https://quotesondesign.com/shawn-lukas-2/",custom_meta:{Source:'<a href="http://shawnlukas.com/reads/cools/">article</a>'}},{ID:2405,title:"Andrew Grove",content:"<p>How well we communicate is determined not by how well we say things, but how well we are understood.</p>\n",link:"https://quotesondesign.com/andrew-grove/"},{ID:559,title:"Mark Gobe",content:"<p>When we feel less secure, with less control over our daily lives, we reach out to brands to connect with a time when things seemed better.  </p>\n",link:"https://quotesondesign.com/mark-gobe/"},{ID:2015,title:"Peter Bilak",content:"<p>Right and wrong do not exist in graphic design. There is only effective and non-effective communication.</p>\n",link:"https://quotesondesign.com/peter-bilak/",custom_meta:{Source:'<a href="http://typographytaboo.blogspot.com/2009/10/peter-bilak-illegibility.html">post</a>'}},{ID:2450,title:"Paula Scher",content:"<p>Less is more and more is more. It’s the middle that’s not a good place.</p>\n",link:"https://quotesondesign.com/paula-scher-4/"},{ID:2447,title:"Paula Scher",content:"<p>That’s why pro bono work is great. You choose to do it, and if you’re choosing to do it to grow your own work, your deal is essentially that you’re not going to collaborate. You’re going to do the job the way you think the job is gonna be done.</p>\n",link:"https://quotesondesign.com/paula-scher-3/"},{ID:2444,title:"Michel Eyquem de Montaigne",content:"<p>Better to be tentative than to be recklessly sure—to be an apprentice at sixty, than to present oneself as a doctor at ten.</p>\n",link:"https://quotesondesign.com/michel-eyquem-de-montaigne/"},{ID:2442,title:"Natalya Shelburne",content:"<p>Don&#8217;t you miss doing creative stuff, as an engineer? Don&#8217;t you miss the creativity of the art world? You can say: I&#8217;m working on an infinite canvas capable of any size and shape, that&#8217;s already glowing every color possible into the eyes of just about everyone on the planet. And I get to decide the kind of experience, feeling, and emotion they are going to have. How is that not creative?</p>\n",link:"https://quotesondesign.com/natalya-shelburne/",custom_meta:{Source:'<a href="https://www.youtube.com/watch?v=1x-x7HfSSnU&t=24s&list=WL&index=2">talk</a>'}},{ID:2439,title:"Achille Castiglioni",content:"<p>Delete, delete, delete and at the end find the ‘core aspect of the design’.</p>\n",link:"https://quotesondesign.com/achille-castiglioni/"},{ID:2436,title:"Jon Hicks",content:"<p>Work hard and be nice to people. No one is born with the ability, and no one owes you anything. If you want to do something, start small and build it up. Then keep doing it!</p>\n",link:"https://quotesondesign.com/jon-hicks/"},{ID:2434,title:"William Childs",content:"<p>All the Photoshop filters in the world won&#8217;t save a weak design.</p>\n",link:"https://quotesondesign.com/william-childs-4/"},{ID:2430,title:"Gemma O’Brien",content:"<p>The great thing about personal work is that it can shape your commercial work. Clients see what you create for yourself and that can be the starting point for a new project, which closes the cap between the work you love making and the work you get paid for.</p>\n",link:"https://quotesondesign.com/gemma-obrien/"},{ID:2425,title:"William Edmund Hick",content:"<p>The time it takes to make a decision increases as the number of alternatives increases.</p>\n",link:"https://quotesondesign.com/william-edmund-hick/"},{ID:2423,title:"John Maeda",content:"<p>Design is a solution to a problem. Art is a question to a problem.</p>\n",link:"https://quotesondesign.com/john-maeda-5/"},{ID:2417,title:"George Nelson",content:"<p>You don’t think your way to creative work. You work your way to creative thinking.</p>\n",link:"https://quotesondesign.com/george-nelson/"},{ID:2415,title:"Ralf Speth",content:"<p>If you think good design is expensive, you should look at the cost of bad design.</p>\n",link:"https://quotesondesign.com/ralf-speth/"},{ID:2413,title:"Ray Bradbury",content:"<p>Those who don’t build must burn.</p>\n",link:"https://quotesondesign.com/ray-bradbury/"},{ID:2411,title:"Massimo Vignelli",content:"<p>Styles come and go. Good design is a language, not a style.</p>\n",link:"https://quotesondesign.com/massimo-vignelli-3/"},{ID:2409,title:"Hillman Curtis",content:"<p>The goal of a designer is to listen, observe, understand, sympathize, empathize, synthesize, and glean insights that enable him or her to make the invisible visible.</p>\n",link:"https://quotesondesign.com/hillman-curtis/"},{ID:2407,title:"Nicholas Negroponte",content:"<p>Where do new ideas come from? The answer is simple: differences. Creativity comes from unlikely juxtapositions.</p>\n",link:"https://quotesondesign.com/nicholas-negroponte/"},{ID:2403,title:"Charles Eames",content:"<p>Recognizing the need is the primary condition for design.</p>\n",link:"https://quotesondesign.com/charles-eames-4/"},{ID:2398,title:"Michael Stinson",content:"<p>Letterspacing creates speedbumps for the reader.</p>\n",link:"https://quotesondesign.com/michael-stinson-3/"},{ID:2396,title:"Alexander Isley",content:"<p>I don&#8217;t think of myself as an artist. I know some designers consider themselves such, but I can&#8217;t. This is not to say that I don&#8217;t hope that our work has artistic merit. Anyway, I never know how someone could proclaim himself or herself to be an &#8216;artist&#8217;; I think it should be a designation best left for others to bestow, much like &#8216;genius&#8217; and &#8216;asshole&#8217;.</p>\n",link:"https://quotesondesign.com/alexander-isley-6/"},{ID:2394,title:"Anthony Liccione",content:"<p>Her complexity is a glorious fire that consumes, while her simplicity goes unapproachable. But if one takes time to understand her, there is something beautiful to find, something simple to be loved. But she goes unloved, for being misunderstood.</p>\n",link:"https://quotesondesign.com/anthony-liccione/"},{ID:2391,title:"Samadara Ginige",content:"<p>A good design solves a problem. A bad design creates many.</p>\n",link:"https://quotesondesign.com/samadara-ginige-4/"},{ID:2389,title:"Rami Hassan",content:"<p>If you spend an hour now, you can save five later.</p>\n",link:"https://quotesondesign.com/rami-hassan/"},{ID:2384,title:"Shawn Lukas",content:"<p>When typography is on point, words become images.</p>\n",link:"https://quotesondesign.com/shawn-lukas/",custom_meta:{Source:'<a href="http://design-milk.com/from-sketch-to-shape-special-edition-wallpaper-by-will-holmes/">sketch</a>'}},{ID:2382,title:"William Childs",content:"<p>Much like music, great art is also found in the spaces between your graphic elements.</p>\n",link:"https://quotesondesign.com/william-childs-3/"},{ID:2379,title:"Ricardo Zea",content:"<p>Learning Web Design is like playing video games: You start small and build your character as you progress, then you beat the boss, literally.</p>\n",link:"https://quotesondesign.com/ricardo-zea/",custom_meta:{Source:'<a href="https://twitter.com/ricardozea/status/675150834108354561">tweet</a>'}},{ID:2376,title:"Michael Stinson",content:"<p>Graphic design is building systems.</p>\n",link:"https://quotesondesign.com/michael-stinson-2/"},{ID:2373,title:"Claude Bernard",content:"<p>Art is I; science is we.</p>\n",link:"https://quotesondesign.com/claude-bernard/",custom_meta:{Source:'<a href="https://archive.org/stream/b21270557/b21270557_djvu.txt">paper</a>'}},{ID:2370,title:"Samadara Ginige",content:"<p>Research not to discover what&#8217;s already there, but to discover what&#8217;s not.</p>\n",link:"https://quotesondesign.com/samadara-ginige-3/",custom_meta:{Source:'<a href="https://twitter.com/SamadaraG/status/658176707409477633">tweet</a>'}},{ID:2367,title:"John D. Cook",content:"<p>When it comes to writing code, the number one most important skill is how to keep a tangle of features from collapsing under the weight of its own complexity.</p>\n",link:"https://quotesondesign.com/john-d-cook/",custom_meta:{Source:'<a href="http://www.johndcook.com/blog/2015/06/18/most-important-skill-in-software/">article</a>'}},{ID:2362,title:"Rebecca Rolfe",content:"<p>Instead of asking the user to make a choice up front, maybe we can set a smart default and see if there is high demand after launch for more customization.</p>\n",link:"https://quotesondesign.com/rebecca-rolfe/",custom_meta:{Source:'<a href="http://www.refinery29.com/female-white-hat-hackers-google-chrome">interview</a>'}},{ID:2358,title:"Ralph Caplan",content:"<p>[Designers&#8217;] primary competence lies not in the technicalities of a craft but in the mastery of a process.</p>\n",link:"https://quotesondesign.com/ralph-caplan-2/",custom_meta:{Source:'<a href="http://www.amazon.com/Design-2nd-Bathroom-Object-Lessons/dp/1563673495">book</a>'}},{ID:2356,title:"Ralph Caplan",content:"<p>Design is a process for making things right, for shaping what people need.</p>\n",link:"https://quotesondesign.com/ralph-caplan/",custom_meta:{Source:'<a href="http://www.amazon.com/Design-There-Bathroom-Object-Lessons/dp/0070097771">book</a>'}},{ID:2352,title:"Vital Lokossou",content:"<p>Tech without design is the business&#8217;s perdition.</p>\n",link:"https://quotesondesign.com/vital-lokossou/"},{ID:2349,title:"Sir Ken Robinson",content:"<p>If you&#8217;re not prepared to be wrong, you&#8217;ll never come up with anything original.</p>\n",link:"https://quotesondesign.com/sir-ken-robinson/"},{ID:2347,title:"Elon Musk",content:"<p>Any product that needs a manual to work is broken.</p>\n",link:"https://quotesondesign.com/elon-musk/"},{ID:2345,title:"Martin LeBlanc",content:"<p>A user interface is like a joke. If you have to explain it, it&#8217;s not that good. </p>\n",link:"https://quotesondesign.com/martin-leblanc/",custom_meta:{Source:'<a href="https://twitter.com/iconfinder/status/472014218267742208">tweet</a>'}},{ID:2343,title:"Startup L. Jackson",content:"<p>Y&#8217;all talk about UX like it&#8217;s just another feature. For a user, it literally is the product. Full stop. Everything else is inside baseball.</p>\n",link:"https://quotesondesign.com/startup-l-jackson/",custom_meta:{Source:'<a href="https://twitter.com/startupljackson/status/523539069444177920?lang=en">tweet</a>'}},{ID:2326,title:"Bruce Ediger",content:"<p>The only &#8220;intuitive&#8221; interface is the nipple. After that it&#8217;s all learned.</p>\n",link:"https://quotesondesign.com/bruce-ediger/",custom_meta:{Source:'<a href="http://www.greenend.org.uk/rjk/misc/nipple.html">website</a>'}},{ID:2323,title:"Victoria Pater",content:"<p>Only show work you like, or you&#8217;ll end up being hired to do things you don&#8217;t like.</p>\n",link:"https://quotesondesign.com/victoria-pater/",custom_meta:{Source:'<a href="https://learnthesecrethandshake.com/victoria-pater/">website</a>'}},{ID:1694,title:"Zuzana Licko and Rudy VanderLans",content:"<p>A mystery is the most stimulating force in unleashing the imagination.</p>\n",link:"https://quotesondesign.com/zuzana-licko-and-rudy-vanderlans/",custom_meta:{Source:'<a href="http://www.emigre.com/Editorial.php">article</a>'}},{ID:2163,title:"Zuzana Licko",content:"<p>We read best what we read most.</p>\n",link:"https://quotesondesign.com/zuzana-licko/"},{ID:1017,title:"Yves Behar",content:"<p>Design is how you treat your customers. If you treat them well from an environmental, emotional, and aesthetic standpoint, you&#8217;re probably doing good design.  </p>\n",link:"https://quotesondesign.com/yves-behar/"},{ID:89,title:"Yogi Berra",content:"<p>You can observe a lot just by watching.   </p>\n",link:"https://quotesondesign.com/yogi-berra/"},{ID:992,title:"Yoda",content:"<p>Do, or do not. There is no &#8220;try&#8221;.  </p>\n",link:"https://quotesondesign.com/yoda/"},{ID:98,title:"Yasin Japardi",content:"<p>There&#8217;s no shortcut for greatness.  </p>\n",link:"https://quotesondesign.com/yasin-japardi/"},{ID:384,title:"Wouter Stokkel",content:"<p>It&#8217;s art if it can&#8217;t be explained. It&#8217;s fashion if no one asks for an explanation. It&#8217;s design if it doesn&#8217;t need explanation.  </p>\n",link:"https://quotesondesign.com/wouter-stokkel/"},{ID:824,title:"Woody Allen",content:"<p>If you&#8217;re not failing every now and again, it&#8217;s a sign you aren&#8217;t doing anything very innovative.  </p>\n",link:"https://quotesondesign.com/woody-allen/",custom_meta:{Source:'<a href="http://ffffound.com/image/776a513f1a3402b2662491e42ae76731f598fc6c">chalkboard</a>'}},{ID:1653,title:"Woody Allen",content:"<p>The best an idea gets is when it&#8217;s in your head.</p>\n",link:"https://quotesondesign.com/woody-allen-2/"},{ID:427,title:"Winston Churchill",content:"<p>However beautiful the strategy, you should occasionally look at the results.  </p>\n",link:"https://quotesondesign.com/winston-churchill/",custom_meta:{Source:'<a href="http://www.amazon.com/gp/product/159253127X?ie=UTF8&tag=css-tricks-20&linkCode=as2&camp=1789&creative=390957&creativeASIN=159253127X">book</a>'}},{ID:1493,title:"Winston Churchill",content:"<p>A pessimist sees the difficulty in every opportunity; an optimist sees the opportunity in every difficulty.</p>\n",link:"https://quotesondesign.com/winston-churchill-2/"},{ID:1828,title:"Winnie The Pooh",content:"<p>I shall sing that first line twice, and perhaps if I sing it very quickly, I shall find myself singing the third and fourth lines before I have time to think of them, and that will be a Good Song.</p>\n",link:"https://quotesondesign.com/winnie-the-pooh/",custom_meta:{Source:'<a href="http://www.greeting-cards-4u.com/PooH/PooHBook/chap8.html">book</a>'}},{ID:2237,title:"Wim Hovens",content:"<p>Good design is in all the things you notice. Great design is in all the things you don&#8217;t.</p>\n",link:"https://quotesondesign.com/wim-hovens/"},{ID:376,title:"Wim Crouwel",content:"<p>You can&#8217;t do better design with a computer, but you can speed up your work enormously.  </p>\n",link:"https://quotesondesign.com/wim-crouwel/"},{ID:1874,title:"Wim Crouwel",content:"<p>Of course design is about problem solving, but I cannot resist adding something personal.</p>\n",link:"https://quotesondesign.com/wim-crouwel-2/"},{ID:2315,title:"Wim Crouwel",content:"<p>The grid is like the lines on a football field. You can play a great game in the grid or a lousy game. But the goal is to play a really fine game.</p>\n",link:"https://quotesondesign.com/wim-crouwel-3/",custom_meta:{Source:'<a href="http://www.adweek.com/fishbowlny/from-the-mouths-of-legends-quotes-from-wim-crouwel-and-massimo-vignelli/275297">interview</a>'}},{ID:2078,title:"Willie Nelson",content:"<p>If I forget the words, they weren’t very memorable in the first place.</p>\n",link:"https://quotesondesign.com/willie-nelson/",custom_meta:{Source:'<a href="http://blog.reaganray.com/post/39936495865/the-best-rise-to-the-top">site</a>'}},{ID:1498,title:"William Strunk Jr.",content:"<p>A drawing should have no unnecessary lines and a machine no unnecessary parts.</p>\n",link:"https://quotesondesign.com/william-strunk-jr/",custom_meta:{Source:'<a href="http://gettingreal.37signals.com/ch01_What_is_Getting_Real.php">article</a>'}},{ID:1857,title:"William Percy Weston",content:"<p>It&#8217;s strange, I&#8217;ve seen colours at times that when I&#8217;ve gone back to check on them, they&#8217;ve vanished…</p>\n",link:"https://quotesondesign.com/william-percy-weston/"},{ID:1120,title:"William Morris",content:"<p>History has remembered the kings and warriors, because they destroyed; art has remembered the people, because they created.  </p>\n",link:"https://quotesondesign.com/william-morris/"},{ID:1608,title:"William Mocca",content:"<p>Wondering is the seed of genius.</p>\n",link:"https://quotesondesign.com/william-mocca/"},{ID:892,title:"William Firebrace",content:"<p>Don&#8217;t think.  </p>\n",link:"https://quotesondesign.com/william-firebrace/",custom_meta:{Source:'<a href="http://www.lomography.com/about/the-ten-golden-rules">Golden Rules of Lomography</a>'}},{ID:1440,title:"William Childs",content:"<p>Sometimes you can draw more inspiration from the people who don&#8217;t believe in you, then from the ones who do. </p>\n",link:"https://quotesondesign.com/william-childs/"},{ID:2313,title:"William Childs",content:"<p>Advertising is the one industry where all the experts seem to be the people who don&#8217;t work in it.</p>\n",link:"https://quotesondesign.com/william-childs-2/"},{ID:1233,title:"William Caslon",content:"<p>When in doubt, use Caslon.  </p>\n",link:"https://quotesondesign.com/william-caslon/"},{ID:1047,title:"William Butler Yeats",content:"<p>Think like a wise man but communicate in the language of the people.  </p>\n",link:"https://quotesondesign.com/william-butler-yeats/"},{ID:1788,title:"William Beck",content:"<p>I have thought about the nature of this creative process and have reached a somewhat aberrant conclusion. I don&#8217;t understand it and I don&#8217;t think anyone else does either.</p>\n",link:"https://quotesondesign.com/william-beck/"},{ID:1214,title:"William Allin",content:"<p>Education is not the answer to the question. Education is the means to the answer to all questions.  </p>\n",link:"https://quotesondesign.com/william-allin/"},{ID:505,title:"William Addison Dwiggins",content:"<p>In the matter of layout, forget art and use horse-sense. The printer-designer&#8217;s  whole duty is to make a clear presentation of the message&#8230; This calls for an exercise of common sense and faculty of analysis rather than for art.  </p>\n",link:"https://quotesondesign.com/william-addison-dwiggins/"},{ID:1489,title:"Will Rogers",content:"<p>Advertising is the art of convincing people to spend money they don&#8217;t have for something they don&#8217;t need.</p>\n",link:"https://quotesondesign.com/will-rogers/",custom_meta:{Source:'<a href="http://oaks.nvg.org/gy5ra2.html">quote archive</a>'}},{ID:1491,title:"Will Rogers",content:"<p>If advertisers spent the same amount of money on improving their products as they do on advertising then they wouldn&#8217;t have to advertise them.</p>\n",link:"https://quotesondesign.com/will-rogers-2/",custom_meta:{Source:'<a href="http://oaks.nvg.org/gy5ra2.html">quote archive</a>'}},{ID:2132,title:"Wihan Meerholz",content:"<p>Tell it like it is, in a way they want to hear it.</p>\n",link:"https://quotesondesign.com/wihan-meerholz/"},{ID:1028,title:"Whitney Hess",content:"<p>&#8220;It looks good&#8221; is the worst feedback you can get.  </p>\n",link:"https://quotesondesign.com/whitney-hess/",custom_meta:{Source:'<a href="http://www.aneventapart.com/2009/chicago/">An Event Apart, Chicago 2009</a>'}},{ID:1030,title:"Whitney Hess",content:"<p><strong>Everybody</strong> is a user experience designer.  </p>\n",link:"https://quotesondesign.com/whitney-hess-2/",custom_meta:{Source:'<a href="http://www.aneventapart.com/2009/chicago/">An Event Apart, Chicago 2009</a>'}},{ID:1938,title:"Wayne Dyer",content:"<p>The difference between a weed and a flower is a judgement.</p>\n",link:"https://quotesondesign.com/wayne-dyer/"},{ID:1580,title:"Warren Buffett",content:"<p>Chains of habit are too light to be felt until they are too heavy to be broken.</p>\n",link:"https://quotesondesign.com/warren-buffett/"},{ID:165,title:"Ward Schumaker",content:"<p>The second best friend you can have (the first being someone who can give you a good job) is another designer or illustrator.  </p>\n",link:"https://quotesondesign.com/ward-schumaker/",custom_meta:{Source:'<a href="http://www.allworth.com/Starting_Your_Career_as_a_Freelance_Illustrator_p/1-58115-199-3.htm">book<a/>'}}];
  
  self.random = function (length) {
    var max = quotes.length -1;
    var min = 0;
    var index = Math.floor(Math.random() * (max - min + 1)) + min;
    
    var quote = quotes[index];
    
    if (quote.content.length > length) 
    	return self.random(length);
    return quote;
  }
              
};

$(document).ready(function(){
    $("middle").hover(function(){
		alert("ok");
        $(this).css("transform", "rotate(6deg)");
        }, function(){
        $(this).css("background-color", "pink");
    });
});



